<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="代采组:">
                  <el-input
                    v-model="form.pgname"
                    placeholder="代采组"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="城市：">
                  <el-select
                    v-model="form.city"
                    placeholder="城市"
                    @change="getMainMarketByCity"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市场：">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    clearable
                    placeholder="市场"
                    @change="onMainMarketChange"
                  >
                    <el-option
                      v-for="item in marketList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="子市场：">
                  <el-select
                    v-model="form.market_sub_id"
                    filterable
                    clearable
                    placeholder="子市场"
                  >
                    <el-option
                      v-for="item in subMarketList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态：">
                  <el-select v-model="form.is_use" placeholder="状态">
                    <el-option key="" value="" label="全部"></el-option>
                    <el-option
                      v-for="item in isUse"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总:&nbsp;&nbsp;&nbsp;&nbsp;代采组{{ resData.total }}组
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="addPg"
            >+创建代采组
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="pgid"
              label="代采组id"
            ></el-table-column>
            <el-table-column align="center" prop="market_name" label="市场">
              <template #default="{ row }">
                <div class="market-name-wrap">
                  <div style="max-height: 200px; overflow-y: auto">
                    <div
                      v-for="item in row.isMarketShowAll
                        ? row.market_names.split('、')
                        : row.market_names.split('、').slice(0, 5)"
                      :key="item"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <el-button
                    v-if="row.market_names.split('、').length > 5"
                    type="text"
                    size="small"
                    ghost
                    @click="handleShowModalMore(row, 'Market')"
                  >
                    {{ row.isMarketShowAll ? "收起" : "查看全部" }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="market_sub_names"
              label="子市场"
            >
              <template #default="{ row }">
                <div class="market-name-wrap">
                  <div style="max-height: 200px; overflow-y: auto">
                    <div
                      v-for="item in row.isMarketSubShowAll
                        ? row.market_sub_names.split('、')
                        : row.market_sub_names.split('、').slice(0, 5)"
                      :key="item"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <el-button
                    v-if="row.market_sub_names.split('、').length > 5"
                    type="text"
                    size="small"
                    ghost
                    @click="handleShowModalMore(row, 'MarketSub')"
                  >
                    {{ row.isMarketSubShowAll ? "收起" : "查看全部" }}
                  </el-button>
                </div>
              </template></el-table-column
            >
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgnick"
              label="代采组昵称"
            ></el-table-column>
            <!--<el-table-column align="center" prop="pgbilling" label="代采组报单名"></el-table-column>-->
            <el-table-column
              align="center"
              prop="supply_num"
              label="绑定商家数量"
            >
              <template #default="scope">
                <span v-if="scope.row.supply_num < 1">{{
                  scope.row.supply_num
                }}</span>
                <el-button
                  v-if="scope.row.supply_num >= 1"
                  type="text"
                  @click="handleClick(scope.row.pgid, 1)"
                  >{{ scope.row.supply_num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="origin_txt"
              label="城市"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="is_use_txt"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="member_num"
              label="代采员数量"
            >
              <template #default="scope">
                <span v-if="scope.row.member_num < 1">{{
                  scope.row.member_num
                }}</span>
                <el-button
                  v-if="scope.row.member_num >= 1"
                  type="text"
                  @click="handleClick(scope.row.pgid, 2)"
                  >{{ scope.row.member_num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
              <template #default="scope">
                <el-button type="text" @click="updatePg(scope.row)">
                  编辑
                </el-button>
                <el-button type="text" @click="PgLog(scope.row)">
                  查看日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="操作日志" :visible.sync="logVisible">
            <el-table :data="logData">
              <el-table-column
                property="action_type"
                label="事件"
                align="center"
              ></el-table-column>
              <el-table-column
                property="action_desc"
                label="内容"
                align="center"
              ></el-table-column>
              <el-table-column
                property="action_admin"
                label="操作人"
                align="center"
              ></el-table-column>
              <el-table-column
                property="create_time"
                label="操作时间"
                align="center"
              ></el-table-column>
            </el-table>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { postGetChildMarket, postGetMainMarket } from "@/openapi/erp/supply.js";
import { removeFalsy } from "@/utils/utils.js";

export default {
  data() {
    return {
      marketList: [], // 市场列表
      subMarketList: [], // 子市场列表
      logVisible: false,
      resData: null,
      logData: null,
      form: {
        market_id: "",
        market_sub_id: "",
        pgname: "",
        create_time: [],
        city: "",
        is_use: "",
      },
      citys: CITY,
      isUse: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "0",
          label: "禁用",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/PurchaseGroup/getList",
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {},
  mounted() {
    this.fetchData();
  },
  methods: {
    // 根据城市获取市场列表
    getMainMarketByCity() {
      postGetMainMarket({ city: this.form.city }).then((res) => {
        this.marketList = res;
        this.subMarketList = [];
        this.form.market_id = "";
        this.form.market_sub_id = "";
      });
    },
    // 切换市场时，重新获取子市场
    onMainMarketChange() {
      postGetChildMarket({ parent_id: this.form.market_id }).then((res) => {
        this.subMarketList = res;
        this.form.market_sub_id = "";
      });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    handleClick(pgid, type) {
      const t = Date.parse(new Date());
      if (type === 1) {
        this.$router.push(`/home/supply/supplyList?pgid=${pgid}&t=${t}`);
      }
      if (type === 2) {
        this.$router.push(`/home/purchase?pgid=${pgid}&t=${t}`);
      }
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = {
          id: val[key].id,
        };
      });
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    addPg() {
      this.$router.push("/home/purchasegroup/addpgroup");
    },
    updatePg(row) {
      this.$router.push(`/home/purchasegroup/updatepgroup/pgid/${row.pgid}`);
    },
    PgLog(row) {
      this.$http
        .get(`/erp/PurchaseGroup/getLog/pgid/${row.pgid}`)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data;
            this.logVisible = true;
          }
        });
    },
    // 查看全部
    handleShowModalMore(row, name) {
      this.$set(row, `is${name}ShowAll`, !row[`is${name}ShowAll`]);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/GetList.vue